import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Klik hier of sleep bestanden naar dit gebied om te uploaden.", -1)
const _hoisted_3 = { class: "ant-upload-hint" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { withDefaults } from 'vue'
import { message } from 'ant-design-vue'
import { FileImageOutlined, UploadOutlined } from '@ant-design/icons-vue'
import fileTypeChecker from 'file-type-checker'

export interface Props {
  uploadButton?: boolean
  allowedExtensions?: string[]
  hiddenExtensions?: string[]
  maxFileSize?: number
  multiple?: boolean
  currentCount?: number
  base64?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Uploader',
  props: {
    uploadButton: { type: Boolean, default: false },
    allowedExtensions: { default: () => ['png', 'jpg', 'jpeg', 'pdf', 'mp4'] },
    hiddenExtensions: { default: () => ['m4v'] },
    maxFileSize: { default: 32 },
    multiple: { type: Boolean, default: true },
    currentCount: { default: 0 },
    base64: { type: Boolean, default: false }
  },
  emits: ['newFileUploaded'],
  setup(__props: any, { emit }) {

const props = __props as { uploadButton: boolean, allowedExtensions: string[], hiddenExtensions: string[], maxFileSize: number, multiple: boolean, currentCount: number, base64: boolean };




const validExtensions = props.allowedExtensions.concat(props.hiddenExtensions)

async function handleUpload (file: File): Promise<boolean> {
  if (!await isValidFile(file)) {
    return false
  }

  if (props.base64) {
    getBase64(file, (base64:string|ArrayBuffer|null) => {
      emit('newFileUploaded', { name: file.name.replace(/\.[^/.]+$/, ''), url: base64 })
    })
  } else {
    emit('newFileUploaded', file)
  }

  return false
}

async function isValidFile (file: File): Promise<boolean> {
  const buffer = await file.arrayBuffer()
  const detectedFile = fileTypeChecker.detectFile(buffer)
  // Validate file type
  if (!hasValidFileType(detectedFile?.extension, validExtensions)) {
    message.error(`Het type ${detectedFile?.extension} wordt niet ondersteund!`)
    return false
  }

  // Validate file size
  if (file.size / 1024 / 1024 > props.maxFileSize) {
    message.error('De maximale bestandsgrootte is ' + props.maxFileSize + 'MB!', 5)
    return false
  }

  return true
}

function getBase64 (img: File, callback: (result: string|ArrayBuffer|null) => void): void {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

function hasValidFileType (type: string|undefined, allowedTypes: string[]): boolean {
  if (!type) return false
  return allowedTypes.includes(type)
}

return (_ctx: any,_cache: any) => {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (__props.multiple || (!__props.multiple && __props.currentCount === 0))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!__props.uploadButton)
          ? (_openBlock(), _createBlock(_component_a_upload_dragger, {
              key: 0,
              class: "uploader",
              "show-upload-list": false,
              "before-upload": handleUpload,
              multiple: __props.multiple,
              capture: null
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FileImageOutlined), { style: {"font-size":"36px","color":"#f38929","margin-bottom":"16px"} }),
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, [
                  _createTextVNode("Toegestaan: " + _toDisplayString(__props.allowedExtensions.join(', ')), 1),
                  _hoisted_4,
                  _createTextVNode("Maximaal: " + _toDisplayString(__props.maxFileSize) + " MB", 1)
                ])
              ]),
              _: 1
            }, 8, ["multiple"]))
          : (_openBlock(), _createBlock(_component_a_upload, {
              key: 1,
              "show-upload-list": false,
              "before-upload": handleUpload,
              multiple: __props.multiple,
              capture: null
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UploadOutlined)),
                    _createTextVNode(" Bestanden uploaden ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["multiple"])),
        (__props.currentCount)
          ? (_openBlock(), _createBlock(_component_a_divider, { key: 2 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})